import { useAppState } from 'hooks/useAppState';
import { Cache } from 'types/util';

export const useNewRestaurantApplicationsCount = (): Cache<number> => {
  const { newRestaurantApplicationsCount } = useAppState();

  return newRestaurantApplicationsCount;
};
